import { render, staticRenderFns } from "./PfaAdviserEnrolment.vue?vue&type=template&id=4af3cb52"
import script from "./PfaAdviserEnrolment.vue?vue&type=script&lang=js"
export * from "./PfaAdviserEnrolment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports